<template>
  <div class="regions-table-container">
    <table class="regions-table">
      <thead>
        <tr>
          <th class="regions-col">Region</th>
          <th class="sources-col">Sources</th>
          <th class="formula-col">Formula</th>
          <th class="levels-col">Levels</th>
        </tr>
      </thead>
      <tbody>
        <!-- Loop over each region key from the regions prop -->
        <template v-for="(dateRanges, regionName, regionId) in regions" :key="regionName">
          <!-- If there are sources for this region -->
          <template v-if="getSources(regionName).length > 0">
            <tr :key="`${regionName}-main-${getSources(regionName)[0].id}`">
              <!-- Region cell with rowspan equal to the number of sources -->
              <td :rowspan="getSources(regionName).length"
                :style="selectedRegion == regionId ? 'border: 3px solid ' + setAlpha(regionColours[regionId], 1) + '; padding: 3px;' : ''">
                <div class="region-info">
                  <!-- <div class="region-name">{{ regionName }}</div> -->
                  <div class="region-toggles">
                    <span
                      :style="getChartView(regionName) == 'Timeseries' ? `font-weight: bold; color: ${setAlpha(regionColours[regionId], 1)}` : ''"
                      @click="setChartView(regionName, 'Timeseries')">Timeseries</span> |
                    <span
                      :style="getChartView(regionName) === 'Spectra' ? `font-weight: bold; color: ${setAlpha(regionColours[regionId], 1)}` : ''"
                      @click="setChartView(regionName, 'Spectra')">Spectra</span>
                  </div>
                  <div class="date-ranges">
                    <div v-for="(range, index) in dateRanges" :key="index" class="date-range">
                      <span :style="`color:` + setAlpha(regionColours[regionId], 1)">{{ formatTime(range[0]) }} - {{
                        formatTime(range[1]) }}</span>
                    </div>
                  </div>
                  <div class="region-controls">
                    <button class="select-region-btn" @click="selectRegion(regionName)"
                      :style="`background-color: ${setAlpha(regionColours[regionId], 1)}`">
                      Select
                    </button>
                    <button class="delete-region-btn" @click="deleteRegion(regionName)">
                      Delete
                    </button>
                  </div>

                </div>
              </td>
              <!-- First source details -->
              <td>
                <div class="source-inline">
                  <select v-model="sourcesMap[regionName][0].name"
                    @change="onSourceChange(regionName, sourcesMap[regionName][0].id, $event.target.value)">
                    <option disabled value="">Select Source</option>
                    <option v-for="option in selectable_sources" :key="option" :value="option">
                      {{ option }}
                    </option>
                  </select>

                  <button class="delete-source-btn" @click="deleteSource(regionName, sourcesMap[regionName][0].id)">
                    Delete
                  </button>
                </div>

                <button v-if="getSources(regionName).length === 1" @click="addNewSource(regionName)"
                  class="add-source-button">
                  +
                </button>
              </td>
              <td>
                <FormulaBuilder :backendResponse="backendResponse" :selectedTimestamps="formattedTimestamps"
                  :interpolatedTimestamps="getInterpolatedTimestamps(dateRanges)"
                  :initialFormula="sourcesMap[regionName][0].formula" :octaveBands="octaveBands"
                  @formulaChanged="(computed, error, regex) => onFormulaChanged(regionName, sourcesMap[regionName][0].id, sourcesMap[regionName][0].name, computed, error, regex)" />
              </td>
              <!-- Levels cell spanning all source rows for this region -->
              <td :rowspan="getSources(regionName).length">
                <RowChart v-if="weightedSpectra && Object.keys(weightedSpectra).length > 0" :region="regionName"
                  :dateRanges="dateRanges" :sources="sourcesMap[regionId] || []" :backendResponse="backendResponse"
                  :weightedSpectra="weightedSpectra" :mlResponse="mlResponse" :chartType="getChartView(regionName)" />
              </td>
            </tr>
            <!-- Additional rows for remaining sources -->
            <tr v-for="(source, index) in getSources(regionName).slice(1)" :key="source.id">
              <td>
                <div class="source-inline">
                  <select v-model="source.name" @change="onSourceChange(regionName, source.id, $event.target.value)">
                    <option disabled value="">Select Source</option>
                    <option v-for="option in selectable_sources" :key="option" :value="option">
                      {{ option }}
                    </option>
                  </select>

                  <button class="delete-source-btn" @click="deleteSource(regionName, source.id)">
                    Delete
                  </button>
                </div>


                <button v-if="index === getSources(regionName).slice(1).length - 1" @click="addNewSource(regionName)"
                  class="add-source-button">
                  +
                </button>
              </td>
              <td>
                <FormulaBuilder :backendResponse="backendResponse" :selectedTimestamps="formattedTimestamps"
                  :interpolatedTimestamps="getInterpolatedTimestamps(dateRanges)" :initialFormula="source.formula"
                  :octaveBands="octaveBands"
                  @formulaChanged="(computed, error, regex) => onFormulaChanged(regionName, source.id, source.name, computed, error, regex)" />
              </td>
            </tr>
          </template>
          <!-- If no sources exist for the region -->
          <template v-else>
            <tr>
              <td
                :style="selectedRegion == regionId ? 'border: 3px solid ' + setAlpha(regionColours[regionId], 1) + '; padding: 3px;' : ''">
                <div class="region-info">
                  <!-- <div class="region-name">{{ regionName }}</div> -->
                  <div class="region-toggles">
                    <span
                      :style="getChartView(regionName) == 'Timeseries' ? `font-weight: bold; color: ${setAlpha(regionColours[regionId], 1)}` : ''"
                      @click="setChartView(regionName, 'Timeseries')">Timeseries</span> |
                    <span
                      :style="getChartView(regionName) === 'Spectra' ? `font-weight: bold; color: ${setAlpha(regionColours[regionId], 1)}` : ''"
                      @click="setChartView(regionName, 'Spectra')">Spectra</span>
                  </div>
                  <div class="date-ranges">
                    <div v-for="(range, index) in dateRanges" :key="index" class="date-range">
                      <span :style="`color:` + setAlpha(regionColours[regionId], 1)">{{ formatTime(range[0]) }} - {{
                        formatTime(range[1]) }}</span>
                    </div>
                  </div>
                  <div class="region-controls">
                    <button class="select-region-btn" @click="selectRegion(regionName)"
                      :style="`background-color: ${setAlpha(regionColours[regionId], 1)}`">
                      Select
                    </button>
                    <button class="delete-region-btn" @click="deleteRegion(regionName)">
                      Delete
                    </button>
                  </div>
                </div>
              </td>
              <!-- No sources: display a cell to add one -->
              <td colspan="2">
                <button @click="addNewSource(regionName)" class="add-source-button">
                  +
                </button>
              </td>
              <td>
                <RowChart v-if="weightedSpectra && Object.keys(weightedSpectra).length > 0" :region="regionName"
                  :dateRanges="dateRanges" :sources="sourcesMap[regionId] || []" :backendResponse="backendResponse"
                  :weightedSpectra="weightedSpectra" :mlResponse="mlResponse" :chartType="getChartView(regionName)" />
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>

  </div>
</template>

<script>
import FormulaBuilder from "./FormulaBuilder.vue";
import RowChart from "./RowChart.vue";


export default {
  name: "RegionsOverlay",
  components: {
    FormulaBuilder,
    RowChart,
  },
  props: {
    // Regions prop with structure:
    // { regionName: Array<[startTime: string, endTime: string]>, ... }
    regions: {
      type: Object,
      required: true,
    },
    selectedRegion: {
      type: Number,
      required: true,
    },
    regionColours: {
      type: Array,
      required: true,
    },
    selectedTimestamps: {
      type: Array,
      required: true,
    },
    backendResponse: {
      type: Object,
      required: true,
    },
    mlResponse: {
      type: Object,
      default: null,
    },
    octaveBands: {
      type: Array,
      default: null,
    },
    // The list of selectable sources for the drop-down (array of strings)
    selectable_sources: {
      type: Array,
      required: true,
    },
    currentRange: {
      type: Array,
      default: null,
    },
    APIparams: {
      type: Object,
      default: null,
    },
    weightedSpectra: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      // Local state mapping region names to an array of source objects.
      // Each source is an object: { id, name, formula, computedValues }
      sourcesMap: {
        // Example:
        // "Region A": [
        //   { id: "s1", name: "Source 1", formula: "a+b", computedValues: [...] },
        //   { id: "s2", name: "Source 2", formula: "a-b", computedValues: [...] }
        // ]
      },
      chartTypes: {
        // "regionName": chartType
      },
      loaded: false,
    };
  },
  computed: {
    formattedTimestamps() {
      return this.selectedTimestamps.map(ts => this.formatDateTime(ts));
    }
  },
  methods: {
    formatDateTime(dt) {
      if (!dt) return "";
      const date = new Date(dt);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    formatTime(dt) {
      if (!dt) return "";
      const date = new Date(dt);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    },
    setChartView(regionName, chartType) {
      this.chartTypes[regionName] = chartType;
    },
    getChartView(regionName) {
      if (!this.chartTypes[regionName]) { //init
        this.chartTypes[regionName] = 'Spectra';
      }
      return this.chartTypes[regionName];
    },
    setAlpha(rgbaString, alpha) {
      if (!rgbaString) rgbaString = 'rgba(100, 100, 100, 0.5)';
      const match = rgbaString.match(
        /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)$/
      );
      if (!match) return rgbaString;
      const [, r, g, b] = match;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    getInterpolatedTimestamps(dateRanges) {
      const timestamps = [];
      dateRanges.forEach(range => {
        if (range && range.length === 2) {
          const start = new Date(range[0]);
          const end = new Date(range[1]);
          let current = new Date(start);
          // Increment current by 10 seconds until current is equal to or exceeds the end time.
          while (current < end) {
            timestamps.push(this.formatDateTime(current));
            current = new Date(current.getTime() + 10000); // 10,000 ms = 10 seconds
          }
        }
      });
      // Sort and remove duplicates if needed
      return Array.from(new Set(timestamps)).sort();
    },
    // Returns the array of sources for a given region; if none, returns an empty array.
    getSources(regionName) {
      return this.sourcesMap[regionName] || [];
    },
    // Called when a formula changes for a source.
    onFormulaChanged(regionName, sourceId, sourceName, computed, error, regex) {
      if (!this.sourcesMap[regionName]) return;
      const index = this.sourcesMap[regionName].findIndex(src => src.id === sourceId);
      if (regionName && sourceId && sourceName && computed && index >= 0) {
        this.sourcesMap[regionName][index].computedValues = computed;
        if (this.sourcesMap[regionName][index].formula !== regex) {
          this.sourcesMap[regionName][index].formula = regex;
        }
      }
      this.$emit("formula-changed", this.sourcesMap);
    },
    // Called when the selected source changes from the drop-down.
    onSourceChange(regionName, sourceId, newName) {
      const sources = this.getSources(regionName);
      const index = sources.findIndex(src => src.id === sourceId);
      if (index !== -1) {
        sources[index].name = newName;
      }
      this.$emit("source-changed", { regionName, sourceId, newName });
    },
    selectRegion(regionName) {
      this.$emit("select-region", regionName);
    },
    // Deletes the given region.
    deleteRegion(regionName) {
      this.$emit("delete-region", regionName);
      delete this.sourcesMap[regionName];
    },
    // Deletes a source from a region.
    deleteSource(regionName, sourceId) {
      const sources = this.getSources(regionName);
      const sourceName = sources.filter(src => src.id === sourceId);
      this.sourcesMap[regionName] = sources.filter(src => src.id !== sourceId);
      this.$emit("delete-source", regionName, sourceName);
    },
    // Adds a new source for a given region.
    addNewSource(regionName, source = "", formula_regex = `bp(${this.currentRange[0]}, ${this.currentRange[1]})`) {
      const newSourceId = "new-" + Date.now() + "-" + Math.random().toString(36).substr(2, 9);
      const newSource = { id: newSourceId, name: source, formula: formula_regex, computedValues: [] };

      if (!this.sourcesMap[regionName]) {
        this.sourcesMap[regionName] = [];
      }
      this.sourcesMap[regionName].push(newSource);
      // this.$emit("add-new-source", { regionName, source: newSource });
    },
  },
};
</script>

<style scoped>
.regions-table-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  /* padding: 10px 50px; */
}

.regions-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: var(--spacing-lg);
}

.regions-table td {
  height: 100%;
}

/* Define column widths: shrink Regions, Sources, and Formula; expand Levels */
.regions-col,
.sources-col,
.formula-col {
  width: 10%;
}

.levels-col {
  width: 70%;
}

.add-source-button {
  font-weight: bold;
  width: var(--icon-size-lg);
  height: var(--icon-size-lg);
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.add-source-button:hover {
  background-color: var(--colour-bg-muted);
}

select {
  font-weight: bold;
  height: var(--control-height-md);
  border-radius: var(--radius-sm);
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.regions-table th,
.regions-table td {
  border: 1px solid #777;
  padding: var(--spacing-sm);
  text-align: center;
  font-size: 0.9em;
}

td {
  height: 100%;
}

.region-info {
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.region-toggles span {
  cursor: pointer;
}


.region-name {
  font-weight: bold;
  margin-bottom: var(--spacing-xs);
}

.date-ranges {
  margin-bottom: var(--spacing-xs);
}

.date-range {
  font-size: 0.85em;
}

.select-region-btn {
  height: var(--control-height-md);
  border: none;
  color: var(--colour-surface);
  font-size: 0.8em;
  cursor: pointer;
  margin-top: var(--spacing-xs);
  border-radius: var(--radius-sm);
}

.delete-region-btn,
.delete-source-btn {
  background-color: red;
  height: var(--control-height-md);
  border: none;
  color: var(--colour-surface);
  font-size: 0.8em;
  cursor: pointer;
  border-radius: var(--radius-sm);
  margin-top: var(--spacing-xs);
}

.add-region button {
  background-color: var(--color-primary);
  color: var(--colour-bg-light);
  border: none;
  border-radius: var(--radius-sm);
  padding: var(--spacing-xs) var(--spacing-md);
  cursor: pointer;
}

.add-region button:hover {
  background-color: var(--color-primary-hover);
}
</style>
